import React from 'react';
import PageTemplate, { NavChevron } from '../../../components/UI/PageTemplate';
import Recharge from '../../../components/TroubleTicket/Forms/Recharge';

const RechargeForm = () => {
  return (
    <>
      <PageTemplate seo="Formulario de recarga">
        <NavChevron
          title="Formulario de recarga"
          level="first"
          directURL="/ayuda"
        />
        <Recharge />
      </PageTemplate>
    </>
  );
};

export default RechargeForm;
